// button.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonToggleComponent } from './button-toggle.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { AsIconComponent } from '@modules/editor/shared/as-components/icon/icon.component';

@NgModule({
  declarations: [ButtonToggleComponent],
  imports: [CommonModule, AsIconComponent, MatButtonToggleModule],
  exports: [ButtonToggleComponent]
})
export class AsButtonToggleModule {

}
